export const getTrackingStatusClass = (item: any) => {

    switch (true) {
        case item.isDelayed && !item.isPart:
            return "v3-bdg v3-g-r";
        case item.isPart:
            return "v3-bdg v3-g-p";
        case item.phase === "Delivered":
            return "v3-bdg v3-g-g";
        case item?.phase === "In-Transit":
            return "v3-bdg v3-g-y";


        default:
            return "v3-bdg v3-g-gr";
    }
};


type NewUpdate = {
    new: number;
    message: string | null;
};
type CustomField = {
    key: string;
    value: string;
    type: string;
};

export type DashBoardItem = {
    airline?: string;
    mawb: string;

    update?: string;
    newMileStone?: string;

    NEWETA?: string;
    NEWETD?: string;

    updatedOn: string;
    createdAt: string;

    origin?: string;
    destination?: string;

    isRead: boolean;

    id: string; // ObjectId string
    addedBy: string;

    for: "air" | "ocean";

    pkts: number;
    weight: number;

    trackingStatus?: string;

    newUpdate: {
        new: number;
        message: string | null;
    };

    isDelayed: boolean;
    isPart: boolean;
    isOnline: boolean;
    isFlightReSchedule: boolean;
    isNullAwb: boolean;
    isEditDisabled: boolean;
    awbLocked: boolean;

    eventsId: string[];

    phase: string;
    groupMilestone: string;

    tag: Record<string, any>;
    shipmentActions: any[];

    contactOrganisation: string;

    emailCount: number;
    whatsappCount: number;

    first: number;
    middle: number;
    last: number;

    uniqueValue: string;

    customFields: CustomField[];
    trackingType: string;
};

const grouped: Record<string, DashBoardItem[]> = {};


export function groupShipments(
    data: DashBoardItem[],
    groupBy?: string,
    customFieldKey?: string
): Record<string, DashBoardItem[]> | null {

    if (!groupBy) return null;

    const grouped = data.reduce<Record<string, DashBoardItem[]>>((acc, item) => {
        let key = "Unknown";

        switch (groupBy) {
            case "carrier":
                key = item?.airline || "No Carrier";
                break;

            case "route":
                key = `${item.origin || "?"} → ${item.destination || "?"}`;
                if (key == "? → ?") key = "No Route";
                break;

            case "date":
                key = item.createdAt?.split(" ")[0] || "Unknown";
                break;

            case "custom":
                key = "Custom Fields";
                if (customFieldKey) {
                    const field = item.customFields?.find(
                        (cf) => cf.key === customFieldKey
                    );

                    key = field?.value || "No Custom Field Selected";
                }
                break;
        }

        if (!acc[key]) acc[key] = [];
        acc[key].push(item);

        return acc;
    }, {});

    // ✅ Move empty/unknown keys to end
    const ordered: Record<string, DashBoardItem[]> = {};

    const emptyKeys = ["Unknown", "No Carrier", "No Custom Field Selected", "", null, "Custom Fields", "? → ?", "No Route"];

    // first add valid keys
    Object.keys(grouped)
        .filter((k) => !emptyKeys.includes(k as any))
        .forEach((k) => {
            ordered[k] = grouped[k];
        });

    // then add empty keys at end
    Object.keys(grouped)
        .filter((k) => emptyKeys.includes(k as any))
        .forEach((k) => {
            ordered[k] = grouped[k];
        });

    return ordered;
}